<template>
    <div class="wrapper">
        <div name="search-modal" class="modal">        
            <div class="contents">
                <!-- back & search-->
                <search-header 
                    @onClose="onClose"
                    @onSearch="onSearch"
                    @closeSearch="closeSearch"
                    :isSearch="isResult"
                    :searchRecentKeyword="searchRecentKeyword"
                    style="margin-bottom: 4px;"
                />
                <!-- tabs -->
                <!-- tab components -->
                <!-- result -->
                <recent v-if="selectedTab === 0 && !isResult" 
                    @tabChange="tabChange"
                    @searchRecent="searchRecent"
                />
                <category v-if="selectedTab === 1 && !isResult" 
                    @tabChange="tabChange"
                    @searchCategory="searchCategory"
                />
                <result style="margin-top: 20px;" v-if="isResult" 
                    :searchItems="searchItems"
                    :selectedIdList="selectedIdList"
                    @selectItem="selectItem"
                    @deleteItem="deleteItem"
                    @onClose="onClose"
                    :autoInjector="autoInjector"
                    :isAdult="isAdult"
                    :selectedCount="selectedCount"
                    :allPayment="allPayment"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SearchHeader from '@/components/molecules/calculator/SearchHeader';
import Result from '@/components/molecules/calculator/Result';

import axios from 'axios';
import Recent from '@/components/molecules/calculator/Recent';
import Category from '@/components/molecules/calculator/Category.vue';
import cookies from '@/utilities/cookie.js';

export default {
    name: 'searchModal',
    props: ['selectedIdList', 'isAdult', 'autoInjector', 'selectedCount', 'allPayment'],
    components: {
        SearchHeader,
        Result,
        Recent,
        Category
    },
    mounted: function()
    {

        this.topFunction();
        // document.body.style.overflow = 'hidden'; // 스크롤 비활성화
    },
    data: function()
    {
        return {
            searchItems: null,
            type: -1, // 0: 소모성 재료, 1: 센서, 2: 기타, 3: 관리기기, 6: 인슐린 펌프
            category: -1, //, 0: 주사기 펜니들, 1: 혈당 검사지, 2: 채혈침,  3: 센서, 4: 인슐린펌프용주사기, 5: 인슐린주사기, 6: 인슐린펌프용주사바늘, 7: 기타, 8: 관리기기, 11: 인슐린 펌프
            selectedTab: 0,
            isResult: false,
            searchRecentKeyword: ''
        }
    },
    methods: {
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        searchCategory: function(keyword, type, category)
        {
            this.type = type;
            this.category = category
            this.searchRecentKeyword = keyword;
        },
        searchRecent: function(keyword)
        {
            this.type = -1;
            this.searchRecentKeyword = keyword;
        },
        tabChange: function(tab)
        {
            this.selectedTab = tab
        },
        closeSearch: function()
        {
            this.searchRecentKeyword = '';
            this.isResult = false;
            this.searChItems = null;
        },
        deleteItem: function(item)
        {
            this.$emit('deleteItem', item)
        },
        selectItem: function(item, count)
        {
            this.$emit('selectItem', item, count)
        },
        onClose : function()
        {
            document.body.style.overflow = ''; // 스크롤 활성화
            this.$emit('onClose');
        },
        onSearch: function(keyword)
        {
            // 검색 수행 
            // 검색결과 리스트 업
            this.fetchSearchResults(keyword);
        },
        fetchSearchResults: async function(query)
        {
            // cookie에 저장
            // console.log(`Searching for: ${query}`);
            if(query !== '')
            {
                try {

                    if(this.type === -1)
                    {   
                        
                        const url = `${process.env.API_DB_ROOT}/diabetes/diabetescalc/item/all/search/${query}`;                   
                        const response = await axios.get(url);
            
                        // console.log("response >>", response.data)     
                        this.searchItems = response.data.data;
                        this.isResult = true;
                    }
                    else 
                    {
                        const url = `${process.env.API_DB_ROOT}/diabetes/item/category/search/${this.category}/${query}`;                   
                        const response = await axios.get(url);
            
                        // console.log("response >>", response.data)     
                        this.searchItems = response.data.data;
                        this.isResult = true;
                    }
                    
                   
                    if(this.searchItems.length === 0 || this.searchItems === null)
                    {
                        this.isResult = true;
                        // this.isNoSearchList = true;
                    }
                    else
                    {
                        this.isResult = true;
                        const searchKeywords = cookies.getLocalStorage("search_keyword");
                        if(searchKeywords === null || searchKeywords === undefined || searchKeywords === '')
                        {
                            cookies.setLocalStorage("search_keyword", `${query}`);
                        }
                        else
                        {
                             
                            const splitKeywords = searchKeywords.split(',');
                            
                            const index = splitKeywords.findIndex(keyword => keyword === query);
                            if(index < 0)
                            {
                                // 10개 제한  
                                if(splitKeywords.length > 9)
                                {
                                    cookies.setLocalStorage("search_keyword",  `${query}, ${splitKeywords[0]},${splitKeywords[1]},${splitKeywords[2]},${splitKeywords[3]},${splitKeywords[4]},${splitKeywords[5]},${splitKeywords[6]},${splitKeywords[7]},${splitKeywords[8]}`);
                                }
                                else
                                {
                                    cookies.setLocalStorage("search_keyword", `${query},${searchKeywords}`);
                                }
                                
                            }
                            else 
                            {
                                // 순서 바꾸기
                                splitKeywords.splice(index, 1);
                                let saveKeywords =`${query}`;
                                splitKeywords.forEach(data => {
                                    saveKeywords += `,${data}`
                                })

                                cookies.setLocalStorage("search_keyword", `${saveKeywords}`);
                            }
                        }
                        // this.isNoSearchList = false;
                    }

                    // document.body.style.overflowY = 'hidden';

                } catch(err) {
                    // this.isSearch = false;
                    // this.isNoSearchList = false;
                    // console.log("Error >>", err);
                    // document.body.style.overflowY = 'auto';
                }
                
            }
            else
            {
                // this.isSearch = false;
                // this.isNoSearchList = false;
                // this.list = null;
            }


        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        z-index: 10;
        top: 0;
        left: 0;
    }

    .modal {
        max-width: 600px;
        height: 100vh;
        width: 100%;
        z-index: 10;
        box-sizing: border-box;
    }


    .contents {
        background: #FFFFFF;
        height: 100vh;
        width: 100%;
        padding: 34px 0px 30px 0px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }

</style>


// WEBPACK FOOTER //
// src/components/modals/calculator/SearchModal.vue